import { gql } from '@apollo/client';

export const HOSTS_DATA = gql`
  query hostsData {
    hostsOverview {
      id
      group_id
      type
      position
      alias
      coord_x
      coord_y
      in_service
      online
      online_booking_enabled
      shell_mode
      device_has_changed
      locked
      mac_addr
      ip_addr
      qr
      user {
        nickname
        uuid
        phone
        deposit
        user_discount

        roles {
          alias
        }
      }

      info {
        shell_version
      }

      bookings {
        id
        from
        to
        hosts
        byClient

        client {
          uuid
          nickname
        }
      }

      counters {
        active_window
      }

      client_sessions {
        id
        started_at
        finished_at
        duration
        elapsed
        time_left
        postpaid
        total_cost

        seances {
          id
          status

          tariff {
            id
            title
            kind
          }
        }
      }
    }

    hostGroupsOverview {
      id
      title
      priority
      customization {
        color
      }
    }
  }
`;
